import tw, { styled } from 'twin.macro';

import { LanguageSection } from './language-section';
import TrainingSection from './training-section';
import CertificationSection from './certification-section';
import { WorkerExperiencesSection } from './worker-experience-section';

export const WorkerSkillsAndLanguage = () => {
  return (
    <div tw="flex flex-col items-start gap-6 pb-4">
      <WorkerExperiencesSection />
      <LanguageSection />
      <TrainingSection />
      <CertificationSection />
    </div>
  );
};

export const StyledSeparator = styled.hr`
  ${tw`block w-full border-t border-primary-300 h-px my-6`}
`;
